import React from "react";
import { Box } from "@mui/material";
import { SkeletonUnitsList } from "../../../components/SkeletonUnitsList/SkeletonUnitsList";
import { PerPage } from "../../../../api/fetchUnitGroupListByAttributes";

export const LoadingState = ({ counter, compactWidth }: { counter: PerPage; compactWidth?: boolean }) => (
  <Box display={"flex"} justifyContent={"center"} mb={2}>
    <SkeletonUnitsList counter={counter} compactWidth={compactWidth} />
  </Box>
);
